"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rgbToHex = exports.returnRgbFromCanvas = exports.removeAlphaFromRGB = exports.preventMultipleZeros = exports.preventExtraHash = exports.lightOrDark = exports.getImageData = exports.getContext2D = exports.getColorComponentFromRgbaString = exports.getAlphaInputValue = exports.generateHorizontalGradient = exports.generateColors = exports.convertRgbString = exports.convertHexToRGBA = exports.checkRgbMinMax = exports.calculateOpacity = exports.addHashSymbol = exports.TRANSPARENT_COLOR = exports.RESET_COLOR = exports.RANGE_CANVAS_WIDTH = exports.RANGE_CANVAS_HEIGHT = exports.PREFIX_CLASSNAME = exports.CANVAS_WIDTH = exports.CANVAS_HEIGHT = void 0;
exports.rgbTohsl = rgbTohsl;
exports.setColorSelector = exports.rgbaValidator = void 0;
exports.setFilledSelectorPosition = setFilledSelectorPosition;
exports.validateHex = exports.validateColorFormat = exports.updateRangeSelectorColor = exports.textValidator = void 0;
var CANVAS_WIDTH = 81;
exports.CANVAS_WIDTH = CANVAS_WIDTH;
var CANVAS_HEIGHT = 70;
exports.CANVAS_HEIGHT = CANVAS_HEIGHT;
var RANGE_CANVAS_WIDTH = 152;
exports.RANGE_CANVAS_WIDTH = RANGE_CANVAS_WIDTH;
var RANGE_CANVAS_HEIGHT = 8;
exports.RANGE_CANVAS_HEIGHT = RANGE_CANVAS_HEIGHT;
var TRANSPARENT_COLOR = "rgba(255,255,255,1)";
exports.TRANSPARENT_COLOR = TRANSPARENT_COLOR;
var RESET_COLOR = "rgb(0,0,0)";
exports.RESET_COLOR = RESET_COLOR;
var PREFIX_CLASSNAME = "super-spectrum";
exports.PREFIX_CLASSNAME = PREFIX_CLASSNAME;
var generateHorizontalGradient = function generateHorizontalGradient(gradientH) {
  gradientH.addColorStop(0.0, "hsl(0,100%,50%)");
  gradientH.addColorStop(0.17, "hsl(298.8, 100%, 50%)");
  gradientH.addColorStop(0.33, "hsl(241.2, 100%, 50%)");
  gradientH.addColorStop(0.5, "hsl(180, 100%, 50%)");
  gradientH.addColorStop(0.67, "hsl(118.8, 100%, 50%)");
  gradientH.addColorStop(0.83, "hsl(61.2,100%,50%)");
  gradientH.addColorStop(1.0, "hsl(360,100%,50%)");
  return gradientH;
};
exports.generateHorizontalGradient = generateHorizontalGradient;
var generateColors = function generateColors(ctx2, context2, rgbaColor) {
  ctx2.clearRect(0, 0, context2.width, context2.height);
  var gradientBlackAndWhite = ctx2.createLinearGradient(1, 1, 1, CANVAS_HEIGHT);
  gradientBlackAndWhite.addColorStop(0, "white");
  gradientBlackAndWhite.addColorStop(1, "black");
  var rgb = convertRgbString(rgbaColor); // Regex to convert rgb string to array
  rgb = rgbTohsl(rgb[0], rgb[1], rgb[2]);
  var hue = Math.round(rgb[0]);
  var gradientColor = ctx2.createLinearGradient(1, 1, CANVAS_WIDTH - 1, 1);
  gradientColor.addColorStop(0, "hsla(" + hue + ",100%,50%,0)");
  gradientColor.addColorStop(1, "hsla(" + hue + ",100%,50%,1)");
  ctx2.fillStyle = gradientBlackAndWhite;
  ctx2.fillRect(0, 0, context2.width, context2.height);
  ctx2.globalCompositeOperation = "multiply"; // Added for showing black and white gradient above other color
  ctx2.fillStyle = gradientColor;
  ctx2.fillRect(0, 0, context2.width, context2.height);
  ctx2.globalCompositeOperation = "source-over"; // Added for showing black all over at the bottom
};
exports.generateColors = generateColors;
var getImageData = function getImageData(context, x, y) {
  return context.getImageData(x, y, 1, 1).data;
};
exports.getImageData = getImageData;
var convertHexToRGBA = function convertHexToRGBA(hexCode) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var hex = hexCode.replace("#", "");
  var result = {};
  if (hex.length === 3) {
    hex = "".concat(hex[0]).concat(hex[0]).concat(hex[1]).concat(hex[1]).concat(hex[2]).concat(hex[2]);
  }
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);
  var alpha = calculateOpacity(opacity);
  result.rbgaString = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
  result.r = r;
  result.g = g;
  result.b = b;
  result.alpha = alpha;
  return result;
};
exports.convertHexToRGBA = convertHexToRGBA;
var rgbToHex = function rgbToHex(r, g, b) {
  r = r.toString(16);
  g = g.toString(16);
  b = b.toString(16);
  if (r.length === 1) r = "0".concat(r);
  if (g.length === 1) g = "0".concat(g);
  if (b.length === 1) b = "0".concat(b);
  var result = {};
  result.rgbString = "#".concat(r).concat(g).concat(b);
  return result;
};
exports.rgbToHex = rgbToHex;
var returnRgbFromCanvas = function returnRgbFromCanvas(x, y, ctx) {
  var imageData = getImageData(ctx, x, y);
  var rgbValue = "rgb(".concat(imageData[0], ",").concat(imageData[1], ",").concat(imageData[2], ")");
  var result = {};
  result.rgbString = rgbValue;
  result.r = imageData[0];
  result.g = imageData[1];
  result.b = imageData[2];
  return result;
};
exports.returnRgbFromCanvas = returnRgbFromCanvas;
var calculateOpacity = function calculateOpacity(opacity) {
  if (opacity >= 1 && opacity <= 100) {
    opacity = opacity / 100;
  }
  return opacity;
};
exports.calculateOpacity = calculateOpacity;
var convertRgbString = function convertRgbString(rgba) {
  var rgbArr = rgba.replace(/[^\d,]/g, "").split(",");
  return [parseInt(rgbArr[0]), parseInt(rgbArr[1]), parseInt(rgbArr[2])];
};
exports.convertRgbString = convertRgbString;
var getContext2D = function getContext2D(ref) {
  return ref.current.getContext("2d", {
    willReadFrequently: true
  });
};
exports.getContext2D = getContext2D;
var setColorSelector = function setColorSelector(x, y, type) {
  var selector = document.querySelector(".".concat(type));
  if (type === "".concat(PREFIX_CLASSNAME, "-range-selector")) {
    y = 0;
  }
  selector.style.left = "".concat(x, "px");
  selector.style.top = "".concat(y, "px");
};
exports.setColorSelector = setColorSelector;
function RGBtoHSV(r, g, b) {
  var rabs, gabs, babs, rr, gg, bb, h, s, v, diff, diffc, percentRoundFn;
  rabs = r / 255;
  gabs = g / 255;
  babs = b / 255;
  v = Math.max(rabs, gabs, babs);
  diff = v - Math.min(rabs, gabs, babs);
  diffc = function diffc(c) {
    return (v - c) / 6 / diff + 1 / 2;
  };
  percentRoundFn = function percentRoundFn(num) {
    return Math.round(num * 100) / 100;
  };
  if (diff === 0) {
    h = s = 0;
  } else {
    s = diff / v;
    rr = diffc(rabs);
    gg = diffc(gabs);
    bb = diffc(babs);
    if (rabs === v) {
      h = bb - gg;
    } else if (gabs === v) {
      h = 1 / 3 + rr - bb;
    } else if (babs === v) {
      h = 2 / 3 + gg - rr;
    }
    if (h < 0) {
      h += 1;
    } else if (h > 1) {
      h -= 1;
    }
  }
  return {
    h: Math.round(h * 360),
    s: percentRoundFn(s * 100),
    v: percentRoundFn(v * 100)
  };
}
function rgbTohsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        return null;
    }
    h /= 6;
  }
  return [h * 360, s * 100, l * 100];
}
function setFilledSelectorPosition(r, g, b, noColor) {
  var hsv = RGBtoHSV(r, g, b);
  var x = Math.min(CANVAS_WIDTH * (hsv.s / 100), CANVAS_WIDTH - 1);
  var y = CANVAS_HEIGHT * (1 - hsv.v / 100);
  setColorSelector(x, y, "".concat(PREFIX_CLASSNAME, "-filled-selector"));
  var hsl = rgbTohsl(r, g, b);
  var hue = RANGE_CANVAS_WIDTH - hsl[0] / 360 * RANGE_CANVAS_WIDTH;
  setColorSelector(hue, 8, "".concat(PREFIX_CLASSNAME, "-range-selector"));
  updateRangeSelectorColor(parseInt(document.querySelector(".".concat(PREFIX_CLASSNAME, "-range-selector")).style.left), noColor);
}
var removeAlphaFromRGB = function removeAlphaFromRGB(color) {
  var finalColor = convertRgbString(color);
  return "rgb(".concat(finalColor[0], ",").concat(finalColor[1], ",").concat(finalColor[2], ")");
};
exports.removeAlphaFromRGB = removeAlphaFromRGB;
var addHashSymbol = function addHashSymbol(hexCode) {
  if (!hexCode.includes("#")) {
    return "#".concat(hexCode);
  } else {
    return hexCode;
  }
};
exports.addHashSymbol = addHashSymbol;
var preventExtraHash = function preventExtraHash(e) {
  if (e.key === "#") {
    e.preventDefault();
  }
};
exports.preventExtraHash = preventExtraHash;
var rgbaValidator = function rgbaValidator(e) {
  var value = e.value;
  if (value.length > 3) {
    return false;
  } else {
    return true;
  }
};
exports.rgbaValidator = rgbaValidator;
var textValidator = function textValidator(e) {
  var value = e.value;
  var reg = /^[0-9\s]*$/;
  if (reg.test(value)) {
    return true;
  } else {
    return false;
  }
};
exports.textValidator = textValidator;
var checkRgbMinMax = function checkRgbMinMax(value, min, max) {
  if (value.length === 0) {
    return 0;
  }
  if (value > max) {
    return max;
  } else if (value < min) {
    return min;
  } else {
    return value;
  }
};
exports.checkRgbMinMax = checkRgbMinMax;
var getColorComponentFromRgbaString = function getColorComponentFromRgbaString(rgba) {
  var rgbArr = rgba.replace(/[^\d.,]/g, "").split(",");
  var result = [];
  rgbArr.forEach(function (item) {
    result.push(Number(item));
  });
  return result;
};
exports.getColorComponentFromRgbaString = getColorComponentFromRgbaString;
var validateHex = function validateHex(color) {
  var regex = /^#(?:[0-9a-fA-F]{3}){1,2}$/;
  if (color.match(regex) === null) {
    return false;
  } else {
    return true;
  }
};
exports.validateHex = validateHex;
var validateRgba = function validateRgba(color) {
  var regex = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*(?:\.\d+)?)\)$/;
  if (color.match(regex) === null) {
    return false;
  } else {
    return true;
  }
};
var validateRgb = function validateRgb(color) {
  var regex = /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
  if (color.match(regex) === null) {
    return false;
  } else {
    return true;
  }
};
var validateColorFormat = function validateColorFormat(color) {
  var hex = validateHex(color);
  var rgb = validateRgb(color);
  var rgba = validateRgba(color);
  if (hex || rgb || rgba) {
    return true;
  } else {
    throw new Error("Invalid Color Format");
  }
};
exports.validateColorFormat = validateColorFormat;
var updateRangeSelectorColor = function updateRangeSelectorColor(left, noColor) {
  var selector = document.querySelector(".".concat(PREFIX_CLASSNAME, "-range-selector"));
  if (noColor) {
    selector.style.backgroundColor = "#333";
    return;
  }
  if (left === RANGE_CANVAS_WIDTH || left <= 8) {
    selector.style.backgroundColor = "rgb(255,0,0)";
  } else {
    selector.style.backgroundColor = "transparent";
  }
};
exports.updateRangeSelectorColor = updateRangeSelectorColor;
var getAlphaInputValue = function getAlphaInputValue() {
  var alpha = Number(document.getElementById("alpha").value);
  return calculateOpacity(alpha);
};
exports.getAlphaInputValue = getAlphaInputValue;
var preventMultipleZeros = function preventMultipleZeros(value, e) {
  if (value.startsWith("0")) {
    e.target.value = 0;
  }
};
exports.preventMultipleZeros = preventMultipleZeros;
var lightOrDark = function lightOrDark(color) {
  var r;
  var g;
  var b;
  var hsp;
  var rgbComponent = getColorComponentFromRgbaString(color);
  r = rgbComponent[0];
  g = rgbComponent[1];
  b = rgbComponent[2];
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
  // Using the HSP value, determine whether the color is light or dark
  if (hsp <= 50) {
    return "dark";
  } else {
    return "light";
  }
};
exports.lightOrDark = lightOrDark;